import { PossibleBusinessObject, type ValidBusinessObject } from '../types'
import { UserAttributeDefs, UserAttributeKeyDatePrecision } from '../types/ModelTypes'
import { DefaultContactDetails, DefaultContactDetailsType } from './commonAttributeSets/DefaultContactDetails'
//import { Address } from './commonAttributeSets/Address';

import { ModelCommon } from './ModelCommon'

const typeName = 'Person'

export type PersonType = ValidBusinessObject & Partial<DefaultContactDetailsType> & {
  firstName?: string,
  /** @deprecated in favour of {@link PersonType.firstName | firstName} */
  first_name?: string,
  lastName?: string,
  /** @deprecated in favour of {@link PersonType.lastName | lastName} */
  last_name?: string,
  name?: string
}

class Person extends ModelCommon implements PersonType {
  constructor(pob: PossibleBusinessObject) {
    super(pob.type ?? typeName, pob)
    this.name = pob.name
    if (pob && (pob.firstName || pob.first_name) && (pob.lastName || pob.last_name))
      this.name = (pob.firstName ?? pob.first_name) + ' ' + (pob.lastName ?? pob.last_name)
  }

  firstName?: string | undefined
  /** @deprecated in favour of {@link PersonType.firstName | firstName} */
  first_name?: string | undefined
  lastName?: string | undefined
  /** @deprecated in favour of {@link PersonType.lastName | lastName} */
  last_name?: string | undefined
  name?: string | undefined
  email?: string | undefined
  date_of_birth?: number | undefined
  phoneNumber?: string | undefined
  /** @deprecated in favour of {@link Person.phoneNumber | phoneNumber} */
  phone_number?: string | undefined
  phone_alternate?: string | undefined

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      firstName: {
        type: 'String',
        editable: true,
        valueFn: () => this.firstName ?? this.first_name,
        // validation: {
        //     regex: /pertempter/i,
        //     pass: false,
        //     invalidMessage: 'Name cannot contain pertempter'
        // }
      },
      lastName: {
        type: 'String',
        editable: true,
        valueFn: () => this.lastName ?? this.last_name,
        // validation: {
        //     regex: /pertempter/i,
        //     pass: false,
        //     invalidMessage: 'Name cannot contain pertempter'
        // }
      },
      date_of_birth: {
        type: 'Date',
        precision: UserAttributeKeyDatePrecision.Date,
        editable: true,
        // validation: {
        //     regex: /pertempter/i,
        //     pass: false,
        //     invalidMessage: 'Name cannot contain pertempter'
        // }
      },

      ...DefaultContactDetails,

      phone_alternate: {
        type: 'String',
        editable: true,
        // validation: {
        //     regex: /pertempter/i,
        //     pass: false,
        //     invalidMessage: 'Name cannot contain pertempter'
        // }
      },
    }
  }
}

export { Person }
